// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rS6J","footer":"styles_footer__2VjJd"};